import { render, staticRenderFns } from "./Nice.vue?vue&type=template&id=46e263a6&"
import script from "./Nice.vue?vue&type=script&lang=js&"
export * from "./Nice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports